import React from "react";
import PropTypes from "prop-types";
import {FormattedMessage} from "react-intl";

import {Box, Table, TableBody, TableHead} from "@mui/material";

import TopTableHeader from "../../../../TopTablesComponents/TopTableHeader";
import TopTableLoader from "../../../../TopTablesComponents/TopTableLoader";
import RetailerStockAlertRow from "./RetailerStockAlertRow";

import {greyishBlue500} from "assets/jss/main";

function RetailerStockAlertTable({ data, loading, currency }) {
    if (loading) {
        return <TopTableLoader />;
    }

    const retailers = data ?? [];

    if (!retailers.length) {
        return (
            <div style={{ color: greyishBlue500, fontSize: "14px", padding: "32px 0", textAlign: "center" }}>
                <FormattedMessage id="dashboard.productsRanking.table.no_result" />
            </div>
        );
    }

    const headers = [
        { label: "#", align: "left" },
        { label: <FormattedMessage id="dashboard.retailerStockAlerts.table.header.retailer" />, align: "left" },
        { label: <FormattedMessage id="dashboard.stockAlerts.table.header.alerts" />, align: "left" },
        { label: <FormattedMessage id="dashboard.stockAlerts.table.header.lostRevenue" />, align: "left" },
        { label: <FormattedMessage id="dashboard.retailerStockAlerts.table.header.topProducts" />, align: "left" },
    ];

    return (
        <Box sx={{ overflowX: "auto" }}>
            <Table size="small" sx={{ minWidth: 600 }}>
                <TableHead>
                    <TopTableHeader headers={headers} />
                </TableHead>
                <TableBody>
                    {retailers.map((retailer, index) => (
                        <RetailerStockAlertRow
                            key={retailer.name ?? index}
                            rank={index + 1}
                            retailer={retailer}
                            currency={currency}
                        />
                    ))}
                </TableBody>
            </Table>
        </Box>
    );
}

RetailerStockAlertTable.propTypes = {
    data: PropTypes.array,
    loading: PropTypes.bool,
    currency: PropTypes.string,
};

export default RetailerStockAlertTable;
